
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-opportunity",
      function () {
        return require("private-next-pages/career-opportunity/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-opportunity"])
      });
    }
  